module.exports = __webpack_public_path__ + "img/lipigo_3.c1cc98e6.png";